<template>
  <div id="app">
    <router-view />

    <portal-target name="destination">
      <!--
  This component can be located anywhere in your App.
  The slot content of the above portal component will be rendered here.
  -->
    </portal-target>
  </div>
</template>

<script>
import websocket from "./utils/websocket/index";

import { startCertifiesTask } from "@/api/login/login.js";
import Vue from "vue";
export default {
  name: "App",
  data() {
    return {};
  },
  created() {
    // TODO: WebSocket 通过单例模式连接ws服务器：
    this.$nextTick(() => {
      const wsInstance = websocket.Instance;
      wsInstance.newvue = this;
      // TODO: WebSocket 将websocket挂载到vue原型上：
      Vue.prototype.$ws = wsInstance;
      let user = JSON.parse(localStorage.getItem("user"));
      // TODO: 连接WebSocket
      if (user?.id) {
        wsInstance.connect(user.id);
      }
    });

    this.starTask();
  },
  methods: {
    //启动证照预警定时任务
    async starTask() {
      let res = await startCertifiesTask();
      if (res.code == 200) {
        console.log("证照预警定时任务启动成功！");
      } else {
        console.log("证照预警定时任务启动失败");
      }
    },
  },
};
</script>

<style>
@import "@/styles/index.css";
@import "@/styles/date-style.less";

body {
  margin: 0;
  max-width: 100% !important;
  max-height: 100% !important;
  font-size: 12px !important;
  background: var(--background);
  color: var(--textColor);
}
#app {
  position: absolute; /* 使用绝对定位 */
  top: 0;
  left: 0;
  width: 100%; /* 设置宽度为父元素（body）的宽度 */
  height: 100%; /* 设置高度为父元素（body）的高度 */
}

/* 更改进度条颜色 */
#nprogress .bar {
  background: var(--background-4) !important;
  height: 2px !important;
}

/* 更改 avnt X6 边线条颜色 */
@keyframes ant-line {
  to {
    stroke-dashoffset: -1000;
  }
}
</style>
